
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisLocatingdeviceTestIec as ObiAisLocatingdeviceTestIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-locatingdevice-test-iec.js';
 
 
 

 
 export const ObiAisLocatingdeviceTestIec = createComponent({
   react: React,
   tagName: 'obi-ais-locatingdevice-test-iec',
   elementClass: ObiAisLocatingdeviceTestIecElement,
   events: {
     
   }
  });
 
 